// ©2024 Austin App House. All rights reserved.
import React, { useCallback, useContext, useEffect } from 'react';
import { toggleModal } from '../../storage/actions/modalsActions';
import { connect } from 'react-redux';
import { ResourceDataTable } from '../../components/datatables/ResourceDataTable';
import { recruitColumns } from '../../utils/constans';
import deleteRecruit from '../../utils/api/delete/deleteRecruit';
import { reloadData } from '../../storage/actions/applicationStateActions';
import { SocketContext } from '../../pages';
import Notification from '../../components/notification';
import DashboardIcon from '../../components/dashboard/icons/DashboardIcon';
import RowActions from '../../components/dashboard/RowActions';

const Recruits = ({ toggleModal, isReload, reloadData }) => {
  const { notificationSocket: socket } = useContext(SocketContext);

  useEffect(() => {
    if (!socket) return undefined;

    const handleDoneImports = (response) => {
      const { message, type } = response;
      Notification(type, { message });
      reloadData();
    };

    socket.on('doneImports', handleDoneImports);

    return () => {
      socket.off('doneImports', handleDoneImports);
    };
  }, [socket, reloadData]);

  const handleDeleteRecruit = useCallback((row) => {
    toggleModal(true, 'confirmModal', true, {
      onAccept: () => {
        toggleModal(true, 'loader');
        deleteRecruit(row._id)
          .finally(() => toggleModal(false, 'loader'));
        reloadData();
      },
      header: `Delete ${row.name || 'recruit'}?`,
      buttonLabels: {
        reject: 'Cancel',
        confirm: 'Delete',
      },
    });
  }, [toggleModal, reloadData]);

  const Actions = useCallback((row) => (
    <RowActions
      alignEnd
      showEdit={false}
      onDelete={() => handleDeleteRecruit(row)}
    />
  ), [handleDeleteRecruit]);

  return (
    <div className="subpage-wrap subpage-wrap--admin">
      <div className="subpage-header">
        <h1 className="subpage-title">Recruits</h1>
        <button
          type="button"
          className="subpage-btn subpage-btn--gold"
          aria-label="Upload CSV"
          onClick={() => toggleModal(true, 'importRecruitsModal')}
        >
          <DashboardIcon name="plus" size={18} strokeWidth="2.5" />
          Upload CSV
        </button>
      </div>

      <div className="subpage-table-scroll">
        <ResourceDataTable
          entity="/api/recruits"
          columns={recruitColumns}
          actions={Actions}
          isReload={isReload}
          sortBy="name"
          className="subpage-datatable"
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  reloadData,
};

const mapStateToProps = state => ({
  isReload: state.applicationState.isReload,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Recruits);
